import { render, staticRenderFns } from "./FormItemEdit.vue?vue&type=template&id=f16ed95c&scoped=true"
import script from "./FormItemEdit.vue?vue&type=script&lang=js"
export * from "./FormItemEdit.vue?vue&type=script&lang=js"
import style0 from "./FormItemEdit.vue?vue&type=style&index=0&id=f16ed95c&prod&lang=css"
import style1 from "./FormItemEdit.vue?vue&type=style&index=1&id=f16ed95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16ed95c",
  null
  
)

export default component.exports